
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import {
  CandidateFeatures,
  CandidateItem
} from "@/lib/model/exambuilder/exam-component/candidate";

@Component({
  components: {
    ModalHeader
  }
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedIdList!: number[];
  @Prop() tags!: string[];
  @Prop({ default: true }) showAddTag!: boolean;
  @Prop({ default: "" }) connectCode!: string;
  @Prop({ default: "" }) judgeOutId!: string;
  @Prop({ default: "" }) passwd!: string;
  @Prop({ default: false }) isHrsPage!: boolean;

  modalTitle: ModalTitle = new ModalTitle();
  tagList: string[] = [];
  candidateTag: string[] = [];
  needReplace = false;

  mounted() {
    this.modalTitle.title = "编辑标签";
    this.modalTitle.hasDesc = false;
  }

  created() {
    // 单人添加标签，加载已有标签，走替换逻辑
    if (this.selectedIdList.length === 1) {
      this.needReplace = true;
      this.candidateTag = this.tags;
    }
    this.getTagList();
  }

  async getTagList() {
    const res = await CandidateFeatures.get();
    this.tagList = res.tag;
  }

  mouseEnterAction() {
    const inputBox: HTMLInputElement = this.$refs
      .selectblur as HTMLInputElement;
    inputBox.blur();
  }

  handleClose() {
    this.tagCancel();
  }

  tagAddSubmit() {
    if (this.selectedIdList.length) {
      CandidateItem.mAddTags(
        this.selectedIdList,
        this.candidateTag,
        this.needReplace
      ).then(res => {
        if (res.code === 0) {
          this.$message.success("添加成功");
          this.tagSubmit();
        }
      });
    } else {
      this.$message.info("您还没有选择需要设置标签的候选人");
    }
  }

  @Emit("on-submit-tag")
  tagSubmit(tags?: []) {
    return tags;
  }

  @Emit("on-cancel-tag")
  tagCancel() {
    console.log("on-cancel-audit");
  }
}
